var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"preview-anchor-tabs"},_vm._l((_vm.tabs),function(tab){return _c('div',{key:tab.value,class:['preview-anchor-tabs-item', { active: _vm.activeTab === tab.value }],on:{"click":function($event){return _vm.$emit('change', tab.value)}}},[_vm._v(_vm._s(tab.label))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }